export default __webpack_public_path__ + "static/media/Green.ffc1827f.jpg";